export const WWW_AVAILABILITY = {
  readyfordelivery: 'Διαθέσιμο',
  'rac-dec': 'Διαθέσιμο Δεκέμβριο',
  twodaydelivery: '2-day delivery',
  comingsoon: 'Αναμένεται',
  soldout: 'Σε συνδρομή',
  blueground: 'Blueground',
  heron: 'Heron',
  vodafone: 'Vodafone',
  available: 'Διαθέσιμο',
  'sell-sold': 'Sold',
  viberpay: 'Viber Pay',
};
